import type { ResponseWithType } from './types';
import type { EventPhoto } from '../../types';

const eventPhoto = ({ data }: ResponseWithType<EventPhoto>): EventPhoto => {
  return data;
};

export default eventPhoto;
